import _ from 'lodash';
import moment from 'moment';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Amount } from '../../../../../../common/components/Amount';
import useMount from '../../../../../../common/hooks/useMount';
import LoadingSpinner from '../../../../../../common/widgets/LoadingSpinner';
import { resources } from '../../../../resources/resources';
import { analyticsService } from '../../../../services/analytics';

export const TotalRevenueCard = () => {
  const { t: translate } = useTranslation();
  const [totalRevenue, setTotalRevenue] = useState<number | undefined>();

  const loadTotalRevenue = async (abortController?: AbortController) => {
    const resp = await analyticsService.getTotalRevenue({
      signal: abortController?.signal,
    });
    if (abortController?.signal.aborted) return;
    if (!resp.hasErrors) {
      setTotalRevenue(resp.data);
    }
  };

  useMount(loadTotalRevenue);

  return (
    <div className="mydash-budget-card">
      <div className="mydash-budget-label">
        {translate(resources.analytics.totalRevenue, {
          0: moment().year(),
        })}
      </div>
      <div className="mydash-budget-balance">
        {!_.isNil(totalRevenue) ? (
          <Amount value={totalRevenue} />
        ) : (
          <LoadingSpinner />
        )}
      </div>
    </div>
  );
};
